import React, { useState } from 'react';
import styled from 'styled-components';
import EsApplyAccoItem from './EsApplyAccoItem';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EsApplyCateListContainer from '../../containers/es/EsApplyCateContainer';
import BrandListContainer from '../../containers/common/BrandContainer';
import { setSelBrandInfoAction } from '../../modules/common/brandModule';
import EsApplyProdContainer from '../../containers/es/EsApplyProdContainer';
import EsApplyDvryComp from './EsApplyDvryComp';
import { setPackLayerAction } from '../../modules/es/esApplyModule';

const EsApplyFormBlock = styled.div`
    padding: 0px 0 120px;
`;

const EsApplyForm = () => {

    const dispatch = useDispatch();

    // Active (외곽선을 굴게 만들어 준다) 상태 관리 State
    const [itemApplyActive, setItemApplyActive] = useState(true);
    const [brandApplyActive, setBrandApplyActive] = useState(false);
    const [prodApplyActive, setProdApplyActive] = useState(false);
    const [dvryApplyActive, setDvryApplyActive] = useState(false);

    // 펼침/접힘 상태 관리 State
    const [itemExpand, setItemExpand] = useState(true);
    const [brandExpand, setBrandExpand] = useState(false);
    const [prodExpand, setProdExpand] = useState(false);
    const [dvryExpand, seDvryExpand] = useState(false);

    const [reloadBrand, setReloadBrand] = useState(false);

    const [curItemTitle, setCurItemTitle] = useState({
        id: 'itemApply',
        no: '01.',
        title: '품목 ',
        subtitle: '*필요한 품목을 선택해 주세요.',
        brand: null
    });

    const [curBrandTitle, setCurBrandTitle] = useState({
        id: 'brandApply',
        no: '02.',
        title: '브랜드 ',
        subtitle: '* 선택하신 품목을 모두 포함하고 있는 브랜드입니다. 한 브랜드만 선택해주세요.',
        brand: null
    });

    const [curProdTitle, setCurProdTitle] = useState({
        id: 'prodApply',
        no: '03.',
        title: '상품 ',
        subtitle: '* 상품의 옵션 및 수량을 선택하여 패키지에 추가해주세요.',
        brand: null
    });

    const [curDvryTitle, setCurDvryTitle] = useState({
        id: 'dvryApply',
        no: '04.',
        title: '배송정보 및 추가사항 ',
        subtitle: null,
        brand: null
    });

    const { selectedBrandItem } = useSelector(
        ({ brandItemsReducer }) => ({
            selectedBrandItem: brandItemsReducer.selectedBrandItem
        })
    );

    useEffect(() => {
        const titleInfo = curBrandTitle;
        titleInfo.brand = selectedBrandItem.brnd_han;
        setCurBrandTitle(titleInfo);
    }, [selectedBrandItem])

    // console.log("EsApplyForm +++++++=======")
    // 품목 선택에서 다음 눌렀을 경우 
    const handleCateNextBtnClick = (selCateIdList) => {
        setItemExpand(false);
        // setItemApplyActive(false);
        setBrandApplyActive(true);
        setBrandExpand(true);
        setReloadBrand(true);
    }

    const handleBrandBtnClick = (isNext) => {
        setBrandExpand(false);

        if (isNext) {
            setProdApplyActive(true);
            setProdExpand(true);
            const titleInfo = curBrandTitle;
            titleInfo.brand = selectedBrandItem.brnd_han;
            setCurBrandTitle(titleInfo);
        } else {
            setItemExpand(true);
            setItemApplyActive(true);
            // dispatch(setSelBrandInfoAction(null));
            // const titleInfo = curBrandTitle;
            // titleInfo.brand = null;
            // setCurBrandTitle(titleInfo);
        }

        dispatch(setPackLayerAction(true));
    }

    const handleProdBtnClick = (isNext) => {
        setProdExpand(false);

        if (isNext) {
            seDvryExpand(true);
            setDvryApplyActive(true);
        } else {
            setBrandExpand(true);
        }
    }


    // 카테고리 리스트 컨테이너 
    const cateListContainer = () => {
        return (
            <EsApplyCateListContainer evtHandler={handleCateNextBtnClick} />
        );
    }

    // 브랜드 리스트 컨테이너 
    const brandListContainer = () => {
        return (
            <BrandListContainer reload={reloadBrand} evtHandler={handleBrandBtnClick} />
        );
    }

    // 상품  리스트 컨테이너 
    const prodListContainer = () => {
        return (
            <EsApplyProdContainer evtHandler={handleProdBtnClick} />
        );
    }

    // 배송 정보는 API 통신이 필요 없으므로 컴포넌트로 처리  
    const dvryContainer = () => {
        return (
            <EsApplyDvryComp evtHandler={handleBrandBtnClick} />
        );
    }

    // Expand Button Click 처리 
    const handlerExpendBtnClick = (isExpand, id) => {


        // 펼침 버튼을 선택 시 , 나머지 항목은 자동 닫힘 
        if (isExpand) {
            setItemExpand((id === "itemApply") ? true : false);
            setBrandExpand((id === "brandApply") ? true : false);
            setProdExpand((id === "prodApply") ? true : false);
            seDvryExpand((id === "dvryApply") ? true : false);
        }
    }

    return (
        <EsApplyFormBlock>
            <form action="">
                <ul className="apply-acco default-acco">

                    <EsApplyAccoItem
                        titleinfo={curItemTitle}
                        active={itemApplyActive} isFirst={true}
                        expand={itemExpand} setExpand={handlerExpendBtnClick}
                        listComponent={cateListContainer()} />

                    <EsApplyAccoItem
                        titleinfo={curBrandTitle}
                        active={brandApplyActive} isFirst={false}
                        expand={brandExpand} setExpand={handlerExpendBtnClick}
                        listComponent={brandListContainer()} />

                    <EsApplyAccoItem
                        titleinfo={curProdTitle}
                        active={prodApplyActive} isFirst={false}
                        expand={prodExpand} setExpand={handlerExpendBtnClick}
                        listComponent={prodListContainer()} />

                    <EsApplyAccoItem
                        titleinfo={curDvryTitle} active={dvryApplyActive}
                        isFirst={false} expand={dvryExpand} setExpand={handlerExpendBtnClick}
                        listComponent={dvryContainer()} />
                </ul>
            </form>
        </EsApplyFormBlock>
    );
};

export default EsApplyForm;